import './Projects.css';
import PropTypes from 'prop-types';


const MediaSlot = ({ youtubeId, imgSrc, pdfSrc, imgAlt, caption }) => (
  <figure className="media">
    {youtubeId ? (
      <div className="video-wrapper">
        <iframe
          src={`https://www.youtube.com/embed/${youtubeId}`}
          title="Demo video"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    ) : pdfSrc ? (
      <div className="pdf-wrapper">
        <iframe
          src={pdfSrc}
          title="Embedded PDF"
          loading="lazy"
        />
      </div>
    ) : (
      imgSrc && <img src={imgSrc} alt={imgAlt || ''} loading="lazy" />
    )}
    {caption && <figcaption className="project-caption">{caption}</figcaption>}
  </figure>
);

MediaSlot.propTypes = {
  youtubeId: PropTypes.string,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  caption: PropTypes.string,
};

const Section = ({ title, children }) => (
  <article className="project-section">
    <h3>{title}</h3>
    {children}
  </article>
);

Section.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};


const D_MCP = () => {
    return(
        <section class="container grid project-contents">
            <br></br>
            <div class="project-contents">
                <h3> 1. Back Ground </h3>
                <br></br>
                <div class="project-text"> 
                    One of the greatest strengths of Large Language Models (LLMs) lies in their ability to bridge users to knowledge and tools <br></br>
                    they may not be familiar with. When combined with the Model Context Protocol (MCP), this capability becomes especially powerful <br></br>
                     — allowing designers to access advanced computational design tools directly through natural language.<br></br>
                    Traditionally, computational design tools have been difficult to integrate seamlessly into a designer’s workflow,<br></br>
                    whether through web-based platforms or Grasshopper interfaces. Even after simplification, these tools often demand a steep learning curve,<br></br>
                    and users must already know which tools exist and which are effective for their particular design challenges.<br></br>
                </div>
                <div class="project-text"> 
                      
                </div>
            </div>

            <br></br>
            <div class="project-contents">
                <h3> 2. Purpose of the Tool </h3>
                <br></br>
                {/* <MediaSlot
                    youtubeId="Dto0YCIbVhM"
                    imgAlt="Tool query and discovery"

                />
                <p class="project-caption"> Available Tool Query from 'd_MCP' </p> */}
                <div class="project-text"> 
                    This tool reimagines that interaction. Instead of navigating complex UIs or memorizing toolsets, <br></br>
                    designers can simply type a text prompt to access computational design functions. By describing what they want <br></br>
                    in natural language, designers can both discover available tools and execute computational processes — bridging the gap between intent and implementation. <br></br>
                </div>
            </div>

            <br></br>
            <div class="project-contents">
                <h3> 3. Demo </h3>
                <br></br>
                <MediaSlot
                    youtubeId="Dto0YCIbVhM"
                    imgAlt="Surface Subdivision"
                />
                <p class="project-caption"> Surface Subdivision Workflow in d_MCP </p>
                <br></br>
                <MediaSlot
                    youtubeId="8vNFBaQZl0k"
                    imgAlt="Tool query and discovery"
                />
                <p class="project-caption"> Block Mapping Workflow in d_MCP </p>
                <div class="project-text"> 
                    This project is conceived as an open-ended and continuously evolving platform. <br></br>
                    The current demo showcases one of the most time-consuming manual processes now automated through MCP within Rhino:  <br></br>
                    - The tool divides a massing surface according to designer-specified logic. <br></br>
                    - The resulting subdivided surfaces are assigned to layers representing facade module types. <br></br>
                    - These surfaces are then automatically mapped with pre-designed block definitions, enabling rapid iteration and visualization of facade options. <br></br>
                    This workflow demonstrates how LLM-driven interaction can make computational design tools more intuitive, accessible, and adaptive to the designer’s way of thinking. <br></br>
                </div>
            </div>
        </section>
    );
}


export default D_MCP;